import { CustomResponseOptionGroupToggle } from '@aon/tws-common-ui-questions';
import { QuestionType } from '@aon/tws-common-ui-questions/build/lib/models';
import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ActionCreators } from '../../../store/CustomQuestionStore';

interface ICustomResponseOptionGroupRankingToggleProps {
	questionType?: QuestionType;
	isMultiple?: boolean;
}
const StyledCustomResponseOptionGroupToggle = styled(CustomResponseOptionGroupToggle)`
	margin-right: 20px;
`;

export function CustomResponseOptionGroupRankingToggle(props: ICustomResponseOptionGroupRankingToggleProps) {
	const { questionType, isMultiple } = props;
	const dispatch = useDispatch();

	return (
		<StyledCustomResponseOptionGroupToggle
			label={ContentConstants.RESPONSE_OPTION_GROUP_RANKING_TOGGLE_LABEL}
			labelInfo={ContentConstants.RESPONSE_OPTION_GROUP_RANKING_TOGGLE_TOOLTIP}
			onToggled={(checked: boolean) => {
				dispatch(ActionCreators.ToggleCustomResponseOptionGroupRanking(checked));
			}}
			disabled={isMultiple}
			checked={questionType === QuestionType.Ranking}
		/>
	);
}
